import { Form, Field } from 'formik';
import {
  Button,
  DialogActions,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import TextFieldNoAutofill from '../common/TextFieldNoAutofill';

/**
 * Employee form used to update a new employee.
 *
 * @param {function} handleClose - called on closing
 * @param {function} submitForm - called on submission
 * @param {boolean} isSubmitting - true if the form is submitting
 */

function UpdateEmployeeForm({
  handleClose, submitForm, isSubmitting, submitButtonText,
}) {
  return (
    <Form>
      <Field
        component={TextFieldNoAutofill}
        name="firstname"
        label="First Name"
        required
        fullWidth
        margin="normal"
      />
      <Field
        component={TextFieldNoAutofill}
        name="lastname"
        label="Last Name"
        required
        fullWidth
        margin="normal"
      />
      <Field
        component={TextFieldNoAutofill}
        name="username"
        label="Username"
        required
        fullWidth
        margin="normal"
      />
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={submitForm} disabled={isSubmitting} color="primary">
          {submitButtonText}
        </Button>
      </DialogActions>
    </Form>
  );
}

UpdateEmployeeForm.propTypes = {
  handleClose: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  submitButtonText: PropTypes.string.isRequired,
};

export default UpdateEmployeeForm;
